import ServiceSubscriptions from "./ServiceSubscriptions";

export function ResellerSubscriptions() {
  return <ServiceSubscriptions resellerView />;
}

export default ResellerSubscriptions;
